import { API_URLS } from '../../../common/constants/routes-config';
import { JSON_PATHS } from '../../../common/constants/mapping.defines';
import { Helper } from '@vfde-fe/ngx-lib/services/helper-utils';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormItemModel } from '../../../common/models/form.model';
import {  map, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
declare let jsonpath: any;

/** FormsCounterService */
@Injectable({
  providedIn: 'root',
})
export class FormsCounterService {
    /** formsList */
    public formsList: FormItemModel[];

    /**
     * FormsCounterServiceconstructor
     * @param helper
     * @param httpClient
     */
   public constructor (
      private helper: Helper,
      private httpClient: HttpClient,
  ) {}
    /**
     * get hub forms
     * @returns Observable<FormItemModel[]>
     */
    public getFormCenterForms (): Observable<FormItemModel[]>  {

          const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

          let baseUrlObj = null;

          baseUrlObj = this.helper.prepareURLForDXL(headers, API_URLS.CENTER_HUB.FORM_GET);

          const requestOptions = {headers};

          return this.httpClient.get(baseUrlObj.url, requestOptions).pipe(map((response: any) => {

              this.formsList = new Array<FormItemModel>();
              if (response) {
                for (const form of response) {
                  const formItem = {
                    name: jsonpath.value(form, JSON_PATHS.FORM_CENTER.FORM_LIST_ITEM.NAME),
                    keywords: jsonpath.value(form, JSON_PATHS.FORM_CENTER.FORM_LIST_ITEM.KEYWORDS),
                    Id: jsonpath.value(form, JSON_PATHS.FORM_CENTER.FORM_LIST_ITEM.ID),
                    listed: jsonpath.value(form, JSON_PATHS.FORM_CENTER.FORM_LIST_ITEM.LISTED),
                };
                this.formsList.push(formItem);
                }
              }

              return this.formsList;
          }), catchError((error) => {

            return throwError(error);
        }));
  }

}
